import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: window.location.origin + "/auth-callback",
    postLogoutRedirectUri: window.location.origin + "/login",
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

const loginRequest = {
  scopes: ['User.Read.All', 'Mail.Read.All', 'Mail.ReadWrite'],
};

const msalInstance = new PublicClientApplication(msalConfig);

export { msalInstance, loginRequest };
